import { z } from "zod";

export const CASH_REGISTER_CREDITS_PER_PACK = 100;
export const MAX_CASH_REGISTER_CREDIT_PACKS = 1000;

export const AddCashRegisterCreditsSchema = z.object({
  cashRegisterCredits: z.coerce.number().min(0).max(MAX_CASH_REGISTER_CREDIT_PACKS),
});

export const defaultAddCashRegisterCreditsValues: AddCashRegisterCreditsForm = {
  cashRegisterCredits: 0,
};

export type AddCashRegisterCreditsForm = z.infer<
  typeof AddCashRegisterCreditsSchema
>;
